import { EnvironnementModel } from '../app/shared/models/environnement.model';

export const environment: EnvironnementModel = {
  production: false,
  baseApiUrl: 'https://dev-emea.api.loreal.net/global/consumer/cbp/v1/oneportal',
  newRelicEnabled: true,
  newRelicScriptFileName: 'new-relic-ww-dev-v1.js',
  msalConfig: {
    auth: {
      clientId: '134f866e-9d86-413d-8ec7-64a4f29108ec',
      authority: 'https://login.microsoftonline.com/e4e1abd9-eac7-4a71-ab52-da5c998aa7ba',
    },
  },
  apiConfig: {
    scopes: [
      'user.read',
      'openid',
      'profile',
      'User.ReadBasic.All',
      'https://connected-beauty-dev.loreal.io/Configuration.Read',
    ],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
};
